import { createLogger } from "../logger";
import guard from "../utils/guard";
import type { GXCornerMobileEvents } from "./types";

const logger = createLogger("stats");

export type StatsEvent = Pick<GXCornerMobileEvents["event"], "name"> & {
  name: "page-load";
};

const environment = (() => {
  switch (import.meta.env.MODE) {
    case "development":
      return "test" as const;
    case "production":
      return "prod" as const;
    case "test":
      return "test" as const;
    case "canary":
      return "canary" as const;
    case "stage":
      return "stage" as const;

    default:
      // Throw error during build time
      if (typeof window === "undefined") {
        throw new Error(`Unsupported stats env ${import.meta.env.MODE}`);
      }

      // Skip stats reporting on client
      return undefined;
  }
})();

export const recordStatsEvent = async (event: StatsEvent) => {
  if (!environment) {
    return;
  }

  const stats: GXCornerMobileEvents = {
    client: {
      "environment": environment,
      "name": "gx-corner-mobile",
      "user-agent": window.navigator.userAgent,
      "version-name": import.meta.env.VERSION,
    },
    event: { ...event, "time-client": new Date().toISOString() },
    schema: { version: "0.0.1" },
  };

  const { error } = await guard(
    fetch(`${import.meta.env.VITE_STATS_API}/v2/events`, {
      body: JSON.stringify(stats),
      headers: { "Content-Type": "application/json" },
      method: "POST",
    }),
  );

  if (error) {
    logger.error("Could not report stats", error, "for event", stats);
    return;
  }

  logger.info(JSON.stringify(stats, undefined, 2));
};
